import PropTypes from "prop-types";
import React from "react";

import Documents from "./Documents";

const CompletedCourse = (props) => {
  const { course } = props;

  const handleCertificateDownload = async () => {
    try {
      const response = await fetch(`/client/certificates/${course.id}`, {
        method: "GET",
        headers: {
          Accept: "application/pdf",
          "X-CSRF-Token": document.querySelector('[name="csrf-token"]').content,
        },
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${course.title}_certyfikat.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        console.error("Failed to download certificate");
      }
    } catch (error) {
      console.error("Error downloading certificate:", error);
    }
  };

  return (
    <div className="flex flex-col lg:p-6 gap-6">
      <div className="w-full max-w-5xl mx-auto">
        <div className="bg-white p-8 shadow-lg">
          {/* Completion Header */}
          <div className="text-center mb-8">
            <div className="inline-flex items-center justify-center w-16 h-16 bg-primaryYellow600 rounded-full mb-4">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M5 13l4 4L19 7"
                />
              </svg>
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              Gratulacje!
            </h2>
            <p className="text-lg text-gray-600">Ukończyłeś kurs pomyślnie</p>
          </div>

          {/* Course Details */}
          <div className="border-t border-b border-gray-200 py-6 mb-6">
            <h3 className="text-xl font-semibold mb-4 text-center">
              {course.title || "Kurs"}
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-center">
              <div className="p-4 bg-gray-50">
                <div className="text-2xl font-bold text-primaryYellow">
                  {course.sections?.length || 0}
                </div>
                <div className="text-sm text-gray-600">Sekcji ukończonych</div>
              </div>
              <div className="p-4 bg-gray-50">
                <div className="text-2xl font-bold text-primaryYellow">
                  {course.sections?.reduce(
                    (total, section) => total + (section.lessons?.length || 0),
                    0,
                  ) || 0}
                </div>
                <div className="text-sm text-gray-600">Lekcji ukończonych</div>
              </div>
              <div className="p-4 bg-gray-50">
                <div className="text-2xl font-bold text-primaryYellow">
                  100%
                </div>
                <div className="text-sm text-gray-600">Postęp kursu</div>
              </div>
            </div>
          </div>

          <div className="mb-6">
            <Documents documents={course.documents} />
          </div>

          <div className="text-center">
            <button
              onClick={() => handleCertificateDownload()}
              className="
                py-2 px-6 bg-black text-white text-md
                hover:bg-primaryYellow
                enabled:cursor-pointer
                transition-colors
              "
            >
              Pobierz certyfikat ukończenia
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

CompletedCourse.propTypes = {
  course: PropTypes.object,
};

export default CompletedCourse;
